import NewLayout from "@components/new-ui/Layout";
import { CompanyTrustBanner } from "@components/Webinar/CompanyTrustBanner";
import IndividualWebinar, { IndividualWebinarProps } from "@components/Webinar/IndividualWebinar";

const HeroSectionData: IndividualWebinarProps = {
    title: "From Clicks to Conversions: WhatsApp Drip Marketing 101",
    listHeading: "Are you running Click-to-WhatsApp ads but struggling to turn those leads into paying customers? In this hands-on webinar, you’ll learn:",
    listText: [
        { label: "Why most Click-to-WhatsApp campaigns fail after the first message" },
        { label: "How to build a high-converting WhatsApp drip funnel in under 30 minutes" },
        { label: "The tools, templates, and timing strategies that top D2C, EdTech, and service brands are using" },
        { label: "A live demo: from ad click to WhatsApp chat to conversion" },
    ],
    mediaUrl: "https://assets.gallabox.com/gb-home/webinar/webinar-3.png",
    speakerList: [
        {
            image: "/vidhya.png",
            name: "Vidhya S",
            role: "Whatsapp Evangelist",
        },
        {
            image: "/shoaib.png",
            name: "Shoaib Ahmed",
            role: "Growth Specialist",
        },
    ],
    youtubeURL: "https://youtu.be/puFdRvba-X0",
    inThisWebinar: "In this hands-on webinar, you'll learn:",
    webinarSlug: "automate-sales-drip-marketing",
};

const Webinar: React.FC = () => {
    return (
        <NewLayout
            title="Automating sales with WhatsApp drip marketing - Gallabox webinars"
            description="Learn how to turn clicks into customers using high-converting WhatsApp drip campaigns in our free masterclass. Get access now"
            canonical="https://gallabox.com/webinars/automate-sales-drip-marketing"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/webinar/webinar-3.png" }}
        >
            <IndividualWebinar {...HeroSectionData} />
            <CompanyTrustBanner />
        </NewLayout>
    );
};

export default Webinar;
